import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { PackageIcon, BookOpenIcon, UsersIcon, HeartIcon, MessageCircleIcon, StarIcon, CheckCircleIcon, VideoIcon, CheckIcon } from 'lucide-react';
export function MagazinPage() {
  const products = [{
    id: 'colectia-completa',
    title: 'Colecția Completă Uite cum CRESC!',
    subtitle: 'Colecția completă',
    bullets: ['Toate cele 6 cursuri online, deblocate progresiv', 'Apeluri săptămânale de grup cu Cristina', 'Materiale practice și acces pe viață'],
    price: '2.985 lei',
    oldPrice: '4.200 lei',
    image: 'https://assets.cdn.filesafe.space/3SQqBp51ZHIpTGzJ3Vu1/media/6a2bf324e5084c4b71a5878f.jpg',
    featured: true,
    badge: 'RECOMANDAT',
    icon: <PackageIcon size={24} data-id="element-1223" />,
    link: '/cresc'
  }, {
    id: 'curs-1',
    title: 'Cunoașterea Dezvoltării',
    subtitle: 'Modulul 1',
    bullets: ['Etapele reale de dezvoltare la fiecare vârstă', 'Diferența dintre variație normală și întârziere', 'Primele tehnici de stimulare aplicabile imediat'],
    price: '395 lei',
    oldPrice: '',
    image: 'https://assets.cdn.filesafe.space/3SQqBp51ZHIpTGzJ3Vu1/media/6a2bf324e5084c4b71a5878a.jpg',
    featured: false,
    icon: <BookOpenIcon size={24} data-id="element-1224" />,
    link: '/curscunoastereadezvoltarii'
  }, {
    id: 'curs-2',
    title: 'Relaționare și Joc',
    subtitle: 'Modulul 2',
    bullets: ['Contact vizual și atenție împărtășită', 'Imitarea — primul pas spre vorbire', 'Jocul funcțional, social și simbolic'],
    price: '395 lei',
    oldPrice: '',
    image: 'https://assets.cdn.filesafe.space/3SQqBp51ZHIpTGzJ3Vu1/media/6a2bf32408984b712926bf80.jpg',
    featured: false,
    icon: <UsersIcon size={24} data-id="element-1225" />,
    link: '/cursrelationaresijoc'
  }, {
    id: 'curs-3',
    title: 'Emoții și Reglare',
    subtitle: 'Modulul 3',
    bullets: ['De ce apar crizele și ce comunică copilul prin ele', 'Toleranța la frustrare, pas cu pas', 'Tehnici de reglare emoțională și limite blânde'],
    price: '395 lei',
    oldPrice: '',
    image: 'https://assets.cdn.filesafe.space/3SQqBp51ZHIpTGzJ3Vu1/media/6a2bf324fc5dba9abbf7a45c.jpg',
    featured: false,
    icon: <HeartIcon size={24} data-id="element-1226" />,
    link: '/cursemotiisireglare'
  }, {
    id: 'curs-4',
    title: 'Structurarea Comunicării',
    subtitle: 'Modulul 4',
    bullets: ['Diferența între limbaj receptiv și expresiv', 'Cum să-l înveți să ceară fără să plângă', 'De la primele sunete la primele propoziții'],
    price: '395 lei',
    oldPrice: '',
    image: 'https://assets.cdn.filesafe.space/3SQqBp51ZHIpTGzJ3Vu1/media/6a2bf324c53e51acc0a6393c.jpg',
    featured: false,
    icon: <MessageCircleIcon size={24} data-id="element-1227" />,
    link: '/curss'
  }, {
    id: 'curs-5',
    title: 'Comportament și Autonomie',
    subtitle: 'Modulul 5',
    bullets: ['De ce apar comportamentele dificile', 'Prevenție, intervenție și de-escaladare calmă', 'Autoservire, rutine și pregătire pentru grădiniță'],
    price: '395 lei',
    oldPrice: '',
    image: 'https://assets.cdn.filesafe.space/3SQqBp51ZHIpTGzJ3Vu1/media/6a2bf32408984b712926bf84.jpg',
    featured: false,
    icon: <StarIcon size={24} data-id="element-1228" />,
    link: '/curscomportamentsiautonomie'
  }, {
    id: 'curs-6',
    title: 'Re-evaluare și Următorii Pași',
    subtitle: 'Modulul 6',
    bullets: ['Cum să măsori progresul corect', 'Ce faci când lucrurile stagnează', 'Când să ceri ajutor profesional suplimentar'],
    price: '395 lei',
    oldPrice: '',
    image: 'https://assets.cdn.filesafe.space/3SQqBp51ZHIpTGzJ3Vu1/media/6a2bf326c53e51acc0a6396c.jpg',
    featured: false,
    icon: <CheckCircleIcon size={24} data-id="element-1229" />,
    link: '/cursreevaluaresiurmatoriipasi'
  }, {
    id: 'evaluare',
    title: 'Evaluare + Plan de intervenție pentru copilul tău',
    subtitle: 'Sesiune 1:1',
    bullets: ['Analiză video în mediul natural al copilului', 'Întâlnire online cu părintele (cu sau fără copil)', 'Raport de evaluare + plan de intervenție personalizat primit pe email/WhatsApp'],
    price: '750 lei',
    oldPrice: '1.000 lei',
    image: 'https://images.unsplash.com/photo-1587654780291-39c9404d7dd0?w=600&q=80',
    featured: false,
    icon: <VideoIcon size={24} data-id="element-1230" />,
    link: '/evaluarecadou'
  }, {
    id: 'consultatie',
    title: 'Consultație Punctuală — Primește răspunsurile de care ai nevoie',
    subtitle: 'Sesiune 1:1',
    bullets: ['Întâlnire online de 30 de minute cu părintele', 'Răspund la toate întrebările tale pe loc', 'Analizez interacțiunea părinte-copil dacă e nevoie'],
    price: '250 lei',
    oldPrice: '',
    image: 'https://images.unsplash.com/photo-1516627145497-ae6968895b74?w=600&q=80',
    featured: false,
    icon: <MessageCircleIcon size={24} data-id="element-1231" />,
    link: '/consultatiepunctuala'
  }];
  return <main className="pt-[100px] md:pt-[140px] pb-[80px] bg-brand-ivory min-h-screen" data-id="element-1232">
      {/* Hero Section */}
      <section className="bg-brand-navy text-white py-16 md:py-24 relative overflow-hidden -mt-[100px] md:-mt-[140px] pt-[140px] md:pt-[180px] mb-16" data-id="element-1233">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-brand-gold/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-1234"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-brand-coral/10 rounded-full blur-3xl translate-y-1/3 -translate-x-1/3 pointer-events-none" data-id="element-1235"></div>

        <div className="container-custom text-center relative z-10" data-id="element-1236">
          <div className="inline-flex items-center gap-2 border border-brand-gold/30 rounded-full px-4 py-1.5 mb-6" data-id="element-1237">
            <StarIcon size={14} className="text-brand-gold" data-id="element-1238" />
            <span className="font-montserrat font-bold text-[12px] uppercase tracking-widest text-brand-gold" data-id="element-1239">
              Cursuri & Programe
            </span>
          </div>

          <h1 className="text-[42px] md:text-[56px] lg:text-[64px] font-playfair mb-6 leading-[1.1] text-white" data-id="element-1240">
            Alege parcursul tău
          </h1>

          <p className="text-[16px] md:text-[18px] text-white/80 max-w-[700px] mx-auto font-source" data-id="element-1241">
            De la primul pas spre claritate până la transformarea profundă prin
            conectare și joc. Toate cursurile și programele pentru dezvoltarea
            copilului tău, într-un singur loc.
          </p>
        </div>
      </section>

      {/* Products Grid */}
      <section className="container-custom" data-id="element-1242">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1243">
          {products.map((product, index) => <motion.div key={product.id} initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className={`bg-white rounded-[24px] overflow-hidden flex flex-col h-full border ${product.featured ? 'border-brand-gold shadow-card-hover' : 'border-brand-beige shadow-card'}`} data-id="element-1244">
              {/* Image Area */}
              <Link to={product.link} className="relative h-[240px] w-full overflow-hidden group block" data-id="element-1245">
                <img src={product.image} alt={product.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-1246" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/60 to-transparent transition-opacity duration-300 group-hover:opacity-80" data-id="element-1247"></div>

                {product.featured && <div className="absolute top-4 right-4 bg-brand-gold text-brand-navy font-montserrat font-bold text-[12px] uppercase tracking-[0.1em] px-3 py-1 rounded-full flex items-center gap-1 shadow-md z-10" data-id="element-1248">
                    <StarIcon size={12} fill="currentColor" data-id="element-1249" /> RECOMANDAT
                  </div>}

                <div className="absolute bottom-4 left-4 bg-brand-gold/90 backdrop-blur-sm text-brand-navy font-montserrat font-bold text-[12px] px-3 py-1.5 rounded-full flex items-center gap-2 z-10" data-id="element-1250">
                  {product.icon}{' '}
                  {product.featured ? 'Program Complet' : 'Curs Online'}
                </div>
              </Link>

              {/* Content Area */}
              <div className="p-8 flex flex-col flex-grow" data-id="element-1251">
                <p className="font-montserrat font-bold text-[11px] uppercase tracking-[0.15em] text-brand-navy/60 mb-2" data-id="element-1252">
                  {product.subtitle}
                </p>

                <h3 className="font-playfair font-bold text-[24px] text-brand-navy mb-2 leading-[1.2]" data-id="element-1253">
                  {product.title}
                </h3>

                <div className="flex items-end gap-3 mb-6" data-id="element-1254">
                  {product.oldPrice && <span className="font-source text-[16px] text-brand-textSecondary line-through" data-id="element-1255">
                      {product.oldPrice}
                    </span>}
                  <span className="font-playfair font-bold text-[28px] text-brand-navy leading-none" data-id="element-1256">
                    {product.price}
                  </span>
                </div>

                <ul className="space-y-3 mb-8 flex-grow" data-id="element-1257">
                  {product.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-1258">
                      <div className="mt-1 flex-shrink-0 w-5 h-5 rounded-full bg-brand-gold/20 flex items-center justify-center" data-id="element-1259">
                        <CheckIcon size={12} className="text-brand-navy" strokeWidth={3} data-id="element-1260" />
                      </div>
                      <span className="font-source text-brand-text" data-id="element-1261">
                        {bullet}
                      </span>
                    </li>)}
                </ul>

                <Link to={product.link} className={`w-full text-center py-4 rounded-[8px] font-montserrat font-bold text-[14px] uppercase tracking-[0.05em] transition-colors duration-300 ${product.featured ? 'bg-brand-gold text-brand-navy hover:bg-brand-navy hover:text-white' : 'bg-brand-beige text-brand-navy hover:bg-brand-gold'}`} data-id="element-1262">
                  Click aici pentru înscriere! →
                </Link>
              </div>
            </motion.div>)}
        </div>
      </section>
    </main>;
}